import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair, LogLevel } from '../../models/index';

class LogLevelPickerController implements angular.IComponentController {
    static $inject = [];

    levels: KeyValuePair<LogLevel, string>[] = [
        { key: LogLevel.Debug,   value: 'Debug' },
        { key: LogLevel.Info,    value: 'Info'  },
        { key: LogLevel.Warning, value: 'Warn'  },
        { key: LogLevel.Error,   value: 'Error' },
        { key: LogLevel.Fatal,   value: 'Fatal' },
    ];
}

export const wtLogLevelPicker: ComponentDefinition = {
    componentId: 'wtLogLevelPicker',
    controller: LogLevelPickerController,
    template: require('./logLevelPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<?',
        model: '=',
        name: '@'
    }
};